"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebBData = exports.AndroidBData = exports.IosBData = exports.BDataMobile = exports.BData = void 0;
const library_1 = require("../../../core/library");
const loader_1 = require("./loader");
const helper_1 = require("../../../core/library/helper");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class BData extends library_1.Library {
    constructor(name, biocathLoader) {
        super(name, biocathLoader);
        return (0, helper_1.withLibraryLoadCheck)(this);
    }
    setCustomerSessionId(customerSessionId) {
        var _a;
        try {
            (_a = window.cdApi) === null || _a === void 0 ? void 0 : _a.setCustomerSessionId(customerSessionId);
        }
        catch (e) {
            console.error(e);
        }
    }
    setContext(context) {
        var _a;
        try {
            (_a = window.cdApi) === null || _a === void 0 ? void 0 : _a.changeContext(context);
        }
        catch (e) {
            console.error(e);
        }
    }
}
exports.BData = BData;
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class BDataMobile extends library_1.Library {
    constructor(name, biocathLoader) {
        super(name, biocathLoader);
        return (0, helper_1.withLibraryLoadCheck)(this);
    }
}
exports.BDataMobile = BDataMobile;
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class IosBData extends BDataMobile {
    constructor(baseUrl, slaveUrl) {
        super('IosBData', new loader_1.IosBDataLoader(baseUrl, slaveUrl));
    }
    setCustomerSessionId(_customerSessionId) {
        throw new Error('Shouldn`t call "setCustomerSessionId" method in IOS');
    }
    setContext(_context) {
        throw new Error('Shouldn`t call "setContext" method in IOS');
    }
}
exports.IosBData = IosBData;
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class AndroidBData extends BDataMobile {
    constructor(url) {
        super('AndroidBData', new loader_1.AndroidBDataLoader(url));
    }
    setCustomerSessionId(_customerSessionId) {
        throw new Error('Shouldn`t call "setCustomerSessionId "method in Android');
    }
    setContext(_context) {
        throw new Error('Shouldn`t call "setContext" method in Android');
    }
}
exports.AndroidBData = AndroidBData;
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class WebBData extends BData {
    constructor(url) {
        super('WebBData', new loader_1.WebBDataLoader(url));
    }
}
exports.WebBData = WebBData;
//# sourceMappingURL=index.js.map